import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { getMsg, setLocale, getLocale } from './Locale.js';
import './UI.js';
import { BasicCamera } from './Diorama/BasicCamera.js';
import { Engine, Language } from './Diorama/Engine.js'
import { Renderer } from './Diorama/Renderer.js';
import { Studio } from './Diorama/Studio.js';
import { Clock, MathUtils } from 'three';
import { Asset, AnimatedAsset } from './Diorama/Asset.js';
import { Group, Object3D } from 'three';
import { Color, NoToneMapping } from 'three';
import { Vector3 } from 'three';
import { PopUp } from './PopUp/PopUp.js';
import { Playground } from './Playground.js'
import { BASIC_TOOLBOX, TUTORIAL_TOOLBOX, codeGenerationDialogs, ADVANCED_TOOLBOX, getBlocks } from './blocks/dialogs.js';
import { Thumbnail } from './Diorama/Thumbnail.js';
import signal from 'signal-js';
import { SimpleUI } from './UI.js';
import { DialogTheme } from './blocks/Theme.js';
import { Session } from './Sharing.js';
import { OrthographicCamera } from 'three';
import { TextureLoader } from 'three';
import { SpriteMaterial } from 'three';
import { Sprite } from 'three';
import { ModelViewerScene } from './Diorama/ModelViewerScene.js';


function decodeHTMLEntities(str) {
    var element = document.createElement("div");

    if (str && typeof str === "string") {
        // strip script/html tags
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
        element.innerHTML = str;
        str = element.textContent;
        element.textContent = "";
    }

    return str;
}


document.addEventListener("DOMContentLoaded", () => {
    //Check language
    var savedLanguage = localStorage.getItem('fake-project-lang');
    if (!savedLanguage) {
        savedLanguage = 'en';
        localStorage.setItem('fake-project-lang', savedLanguage);
    }

    setLocale(savedLanguage);

    const DIALOGS = getBlocks();
    const container = document.querySelector('#stage');

    const clock = new Clock();
    //const scene = new Studio(1.5);
    const camera = new BasicCamera(container);

    const renderer = new Renderer(container);

    const scene = new ModelViewerScene(renderer);
    camera.position.z = 3;
    camera.position.y = 1.70;
    camera.lookAt(new Vector3(0, 1.70, 0));
    //const orbit = new OrbitControls(camera, renderer.domElement);
    //orbit.update();
    var repository = {};

    PopUp.inject('#stage', "speech");
    var lastAnswer = '';
    class MyLanguage extends Language {
        static ASYNC_METHODS = ["saysForSeconds", "asks", "showMenu"];

        getAnswer() {
            return lastAnswer;
        }

        asks(question, callback) {
            console.log(question);
            const randomID = Math.floor(Math.random() * 1000);
            const questionElement = `<div class="question"><h2>${question}</h2><input type="text" id="answer-input-${randomID}"></input><button id="question-button-${randomID}">Answer</button></div>`;
            PopUp.showMessage(questionElement);
            document.querySelector('#question-button-' + randomID).addEventListener('click', () => {
                const currentAnswer = document.querySelector('#answer-input-' + randomID).value;
                lastAnswer = currentAnswer ? currentAnswer : '';
                PopUp.hide();
                callback();
            });
        }
        setLabel(label) {
            PopUp.setLabel(label)
        }
        says(msg) {
            PopUp.showMessage(msg)
        }

        showMenu(msg, options, callback) {


            var optionsHTML = '';
            var idCounter = 0;
            for (let option in options.properties) {
                if (!options.properties[option])
                    continue;

                const optionHTML = `
                
                    <input type="radio" id="option-${idCounter}" name="answer" value="${options.properties[option]}">
                    <label for="option-${idCounter}">${options.properties[option]}</label>
                
                `;
                optionsHTML += optionHTML;
                idCounter++;
            }

            var menuHTML = `
            <h3>${msg}</h3>
            <div class="menu-options">
                ${optionsHTML}
            </div>
            <div class="menu-options-button"><button id="answer-button" style="background-image: url(./images/ok.svg)">Confirm</button></div>
            `;

            PopUp.showMessage(menuHTML)
            document.querySelector('#answer-button').addEventListener('click', (event) => {
                const currentAnswers = document.querySelectorAll('input[name=answer]');
                var currentAnswer;
                for (let answer of currentAnswers) {
                    if (answer.checked) {
                        currentAnswer = answer.value;
                        break;
                    }
                }

                lastAnswer = currentAnswer ? currentAnswer : '';
                PopUp.hide();
                callback();
            })
        }

        saysForSeconds(msg, seconds, callback) {
            console.log(msg, seconds)
            PopUp.showMessage(msg)
            setTimeout(callback, seconds * 1000);
        }
        clear() {
            for (let object of scene.children) {
                if (object.isAsset || object.isSprite) {
                    object.visible = false;
                }
            }
        }
        hide(areaID) {
            PopUp.hide()
        }
        show(name, animation = 'Idle') {
            for (let object of characterAssets) {
                if (object.name === name) {
                    object.visible = true;
                    if (object.isAnimated) {
                        if (animation === 'Death') {
                            object.activateAllAnimation(animation);
                            object.play(animation, 0)
                        } else {
                            object.activateAllAnimation(animation);
                        }
                    }
                } else if (object.isAsset) {
                    object.visible = false;
                }
            }
        }
        showEmotion(emotion) {
            // const map = new THREE.TextureLoader().load(`./emoji/emote_${emotion}.png`);
            // const material = new THREE.SpriteMaterial({ map: map });
            console.log("EMOTION", emotion)
            const emotionObject = scene.getObjectByName("Emotion");
            emotionObject.material.map = emotionsMaps[emotion];
            emotionObject.visible = true;
            // const sprite = new THREE.Sprite(material);
            // scene.add(sprite);
        }
        hideEmotion() {
            const emotionObject = scene.getObjectByName("Emotion");
            emotionObject.visible = false;
        }
        showLocation(name) {
            for (let object of loactionAssets) {
                if (object.name === name) {
                    object.visible = true;
                } else if (object.isAsset) {
                    object.visible = false;
                }
            }
        }

        rotateCamera(angle) {

            scene.rotation.y = MathUtils.degToRad(angle)
        }

    }

    const engine = new Engine(MyLanguage);

    const code = `
    
    `;
    var playground;
    var session;

    var storyID;


    const initWorkspace = (toolbox = BASIC_TOOLBOX, workspaceID = 'fake-workspace', initialWorkspace = '<xml xmlns="https://developers.google.com/blockly/xml"><block type="show_location" id="%CMry^mQoOc|b]et8XFW" x="-10" y="10"><value name="LOCATION"><shadow type="get_location" id="GyQ=IF`!m@D0P=hlvnnb"><field name="BASE">location2.glb</field></shadow></value><next><block type="show" id="0.kYAIS3-C{BPSC5Wd8+"><field name="ANIMATION">Idle</field><value name="CHARACTER"><shadow type="get_character" id="4-Ox8;7^J`V=NWlMU^2C"><field name="BASE">Casual2_Female.gltf</field></shadow></value><next><block type="wait_seconds" id="XZ?NUF3yZE0-|s6Pdzl6"><field name="SECONDS">1</field><next><block type="says_for_seconds" id="y`ftCC[vCu]Hz=y1{zD*"><field name="SECONDS">1</field><value name="MESSAGE"><shadow type="text" id="rt1gmdANPrYtB6;vAY(V"><field name="TEXT">Welcome!</field></shadow></value><next><block type="says_for_seconds" id="!IBHBvu^%yq*yUD.{lUV"><field name="SECONDS">2</field><value name="MESSAGE"><shadow type="text" id="(Lyd{%=lnO6@@XyAtAz)"><field name="TEXT">Start your story by adding new blocks!</field></shadow></value><next><block type="show" id="$#l0Y-?2:W4UD9egLaF*"><field name="ANIMATION">Victory</field><value name="CHARACTER"><shadow type="get_character" id="zTxTQ`TpZ!E*5%52jGJa"><field name="BASE">Casual2_Female.gltf</field></shadow></value><next><block type="says_for_seconds" id="2b(^8N[C_`Oj$XN?!P@o"><field name="SECONDS">3</field><value name="MESSAGE"><shadow type="text" id="[U~$|5gjNHg!_f|j#~Id"><field name="TEXT">Have fun and explore!</field></shadow></value><next><block type="show" id="Fx%iZ.Rj1PI@ii-1=_3Q"><field name="ANIMATION">Idle</field><value name="CHARACTER"><shadow type="get_character" id="%AZ2@%MFBmL4?MVRWI{Y"><field name="BASE">Casual2_Female.gltf</field></shadow></value></block></next></block></next></block></next></block></next></block></next></block></next></block></next></block></xml>') => {
        document.querySelector("#workspace").innerHTML = '';
        document.querySelector('#workspace').style.display = 'block';
        //Set language
        playground = new Playground('#workspace', codeGenerationDialogs, toolbox, DIALOGS, DialogTheme, () => {
            localStorage.setItem(workspaceID, playground.getWorkspace());

        });


        const lastWorkspace = localStorage.getItem(workspaceID);
        if (lastWorkspace)
            playground.setWorkspace(lastWorkspace);
        else {
            playground.setWorkspace(initialWorkspace);
        }
        window.playground = playground;
        playground.workspace.cleanUp();
        //playground.workspace.zoomToFit();

        window.engine = engine;
        engine.run(code, (reason, error) => {
            console.log(reason, error ? error : 'no error')
        });
    }

    const onLocationsLoaded = (assets) => {
        const width = 128;
        const height = 64;
        thumbnail.camera = new OrthographicCamera(- width / 2, width / 2, height / 2, - height / 2, 0, 2000);
        thumbnail.camera.position.x = 0;
        thumbnail.camera.position.y = 5;
        thumbnail.camera.position.z = 15;
        thumbnail.camera.lookAt(0, 0, 0);
        thumbnail.camera.zoom = 10;
        thumbnail.renderer.setSize(width, height);
        const generatedImageOptions = generateThumbnails(assets, width, height);
        for (let block of DIALOGS) {
            if (block.type === 'get_location') {

                block.args0[0].options = generatedImageOptions;
            }
        }

    }

    const onStuffLoaded = (assets) => {
        //thumbnail.setZoom(25);
        const generatedImageOptions = generateThumbnails(assets);
        for (let block of DIALOGS) {
            if (block.type === 'get_stuff') {

                block.args0[0].options = generatedImageOptions;
            }
        }

    }

    const onCharactersLoaded = (assets) => {
        const generatedImageOptions = generateThumbnails(assets);

        for (let block of DIALOGS) {
            if (block.type === 'get_character') {
                block.args0[0].options = generatedImageOptions;
            }
        }

        for (let asset of assets) {
            asset.activateAllAnimation();
        }

    }
    const thumbnail = new Thumbnail(192, 256);
    const inventory = document.createElement('div');
    inventory.setAttribute('id', 'inventory');

    function generateThumbnails(assets, width = 48, height = 64) {
        const thumbnails = [];
        for (let asset of assets) {
            const newImageOption = [
                {
                    "width": width,
                    "height": height,
                    "alt": asset.name.indexOf('.glb') > 0 ? asset.name.replace('.glb', '') : asset.name.replace('.gltf', '')
                },
                asset.name
            ];
            newImageOption[0].src = thumbnail.generate(asset, inventory);
            thumbnails.push(newImageOption);
        }
        return thumbnails;
    }

    function animate() {
        requestAnimationFrame(animate);

        const delta = clock.getDelta();
        const animatedAssets = scene.children.filter((o) => { return o.isAnimated });
        for (let a of animatedAssets) {
            a.update(delta)
        }
        if (renderer.starts)
            renderer.stats.update();
        renderer.render(scene, camera);
    }
    animate();

    window.addEventListener('resize', onWindowResize, false);

    function onWindowResize() {
        console.log(container)

        camera.aspect = container.clientWidth / container.clientHeight;
        camera.updateProjectionMatrix();

        renderer.setSize(container.clientWidth, container.clientHeight);

    }



    const skinTones = ['#d8bba9', '#d6aa8d', '#c68e77',
        '#96634e', '#664d48', '#3b3c37'];
    var skinCounter = 0;

    function loadCharacters(filenames, callback = (assets) => {
        console.log('Assets loaded', assets)
    }) {
        const assets = [];
        const total = filenames.length;
        var ready = 0;
        var loadedPercentage = (1 / total);
        document.querySelector('#loading-screen').style.display = 'flex';
        const skinPerModel = {};
        for (let filename of filenames) {
            skinPerModel[filename.replace(/^.*[\\\/]/, '')] = skinTones[skinCounter % skinTones.length];
            skinCounter++;
            const asset = new AnimatedAsset(filename, (model, group) => {
                const originalSkin = ['Goblin_Female.gltf', 'Goblin_Male.gltf']

                if (group.name == 'OtherMale.glb' || group.name == 'OtherMaleSuit.glb')
                    model.scale.set(0.5, 0.5, 0.5);
                else if (group.name == 'avatar.glb')
                    model.scale.set(1.6, 1.6, 1.6);
                else
                    model.traverse((o) => {
                        if (o.isMesh) {
                            //o.material.metalness = 1;
                            o.material.roughness = 1;
                            if (o.material.name.indexOf('Skin') >= 0 && !originalSkin.includes(group.name)) {
                                // const newSkin = new MeshPhongMaterial({
                                //     color: new Color(skinTones[skinCounter % skinTones.length])
                                // })
                                o.material.color = new Color(skinPerModel[group.name]).convertSRGBToLinear();
                                //o.material.roughness = 1;
                                //console.log(o.material)
                                // o.material = newSkin;

                            }
                            //console.log(o.material.name)
                            if (o.material.name.indexOf('Face') >= 0) {
                                o.material.color = new Color("#111111");
                            }
                            //o.material.color = new Color("#ffffff")
                        }
                    })
                assets.push(group);
                repository[filename] = model;

                loadedPercentage = (1 / filenames.length) * ready;
                document.querySelector('#loading-popup h3').innerText = getMsg("LOADING_CHARACTERS")
                const loadingBar = document.querySelector('#loading-bar');
                loadingBar.style.width = Math.floor(loadedPercentage * 200) + 'px'

                ready++;
                if (ready == total) {
                    document.querySelector('#loading-screen').style.display = 'none';
                    callback(assets)
                }
            });

        }
    }


    function loadStuff(filenames, callback = (assets) => {
        console.log('Assets loaded', assets)
    }) {
        const assets = [];
        const total = filenames.length;
        var ready = 0;

        var loadedPercentage = (1 / total);
        document.querySelector('#loading-screen').style.display = 'flex';

        for (let filename of filenames) {

            const asset = new Asset(filename, (model, group) => {

                assets.push(group);
                repository[filename] = model;

                loadedPercentage = (1 / filenames.length) * ready;
                document.querySelector('#loading-popup h3').innerText = getMsg("LOADING_CHARACTERS")
                const loadingBar = document.querySelector('#loading-bar');
                loadingBar.style.width = Math.floor(loadedPercentage * 200) + 'px'

                ready++;
                if (ready == total) {
                    document.querySelector('#loading-screen').style.display = 'none';
                    callback(assets)
                }
            });

        }
    }

    function loadLocations(filenames, callback = (assets) => {
        console.log('Assets loaded', assets)
    }) {
        const assets = [];
        const total = filenames.length;
        var ready = 0;

        var loadedPercentage = (1 / total);
        document.querySelector('#loading-screen').style.display = 'flex';
        for (let filename of filenames) {

            const asset = new Asset(filename, (model, group) => {
                model.traverse((o) => {
                    if (o.type.indexOf("Light") >= 0) {
                        o.visible = false;
                    }
                    if (o.isMesh) {
                        o.receiveShadow = true;
                        o.material.metalness = 0;
                        o.material.roughness = 0.9;
                    }
                });
                assets.push(group)
                repository[filename] = model;
                ready++;
                loadedPercentage = (1 / filenames.length) * ready;
                document.querySelector('#loading-popup h3').innerText = getMsg("LOADING_LOCATIONS");
                const loadingBar = document.querySelector('#loading-bar');
                loadingBar.style.width = Math.floor(loadedPercentage * 200) + 'px'
                if (ready == total) {
                    document.querySelector('#loading-screen').style.display = 'none';
                    callback(assets)
                }
            });

        }
    }
    const characterAssets = [];
    const loactionAssets = [];
    const emotionsMaps = {};

    //"./assets/Ninja_Sand.gltf","./assets/Knight_Golden_Male.gltf", "./assets/Knight_Golden_Female.gltf", "./assets/BaseCharacter.gltf", "./assets/BlueSoldier_Male.gltf", "./assets/BlueSoldier_Female.gltf",
    const stuff = ["./assets/FirstAid.glb", "./assets/Compass.glb", "./assets/Phone1.glb", "./assets/Phone2.glb", "./assets/Phone3.glb", "./assets/Covid19.glb", "./assets/Laptop1.glb", "./assets/Laptop2.glb", "./assets/Cactus.glb"];
    const models = ["./assets/Bigger_Male.glb", "./assets/Casual2_Female.gltf", "./assets/Zombie_Male.gltf", "./assets/Zombie_Female.gltf",
        "./assets/Worker_Male.gltf", "./assets/Worker_Female.gltf", "./assets/Wizard.gltf", "./assets/Witch.gltf", "./assets/VikingHelmet.gltf", "./assets/Viking_Male.gltf",
        "./assets/Viking_Female.gltf", "./assets/Suit_Male.gltf", "./assets/Suit_Female.gltf", "./assets/Soldier_Male.gltf", "./assets/Soldier_Female.gltf", "./assets/Pug.gltf",
        "./assets/Pirate_Male.gltf", "./assets/Pirate_Female.gltf", "./assets/OldClassy_Male.gltf", "./assets/OldClassy_Female.gltf", "./assets/Ninja_Sand_Female.gltf",
        "./assets/Ninja_Male_Hair.gltf", "./assets/Ninja_Male.gltf", "./assets/Ninja_Female.gltf", "./assets/Knight_Male.gltf",
        "./assets/Kimono_Male.gltf", "./assets/Kimono_Female.gltf", "./assets/Goblin_Male.gltf",
        "./assets/Goblin_Female.gltf", "./assets/Elf.gltf", "./assets/Doctor_Male_Young.gltf", "./assets/Doctor_Male_Old.gltf", "./assets/Doctor_Female_Young.gltf", "./assets/Doctor_Female_Old.gltf", "./assets/Cowboy_Male.gltf", "./assets/Cowboy_Hair.gltf", "./assets/Cowboy_Female.gltf", "./assets/Cow.gltf", "./assets/Chef_Male.gltf", "./assets/Chef_Hat.gltf", "./assets/Casual_Male.gltf", "./assets/Chef_Female.gltf", "./assets/Casual_Female.gltf", "./assets/Casual_Bald.gltf", "./assets/Casual3_Male.gltf", "./assets/Casual3_Female.gltf", "./assets/Casual2_Male.gltf"];
    const locations = ["./assets/locations/Wood.glb", "./assets/locations/Wood2.glb", "./assets/locations/Wood3.glb", "./assets/locations/Forest.glb", "./assets/locations/City.glb", "./assets/locations/CityWar.glb", "./assets/locations/location2.glb", "./assets/locations/location3.glb"];
    const emotions = ["./emoji/star.png", "./emoji/speechless.png", "./emoji/sleep.png", "./emoji/sad.png", "./emoji/question.png", "./emoji/positive.png", "./emoji/negative.png", "./emoji/lovenot.png", "./emoji/love.png", "./emoji/idea.png", "./emoji/happy.png", "./emoji/esclamation.png", "./emoji/dizzy.png", "./emoji/angry.png"];

    function loadEmotions(filenames, callback = (assets) => {
        console.log('Emotions loaded', assets)
    }) {
        for (let filename of filenames) {
            const map = new TextureLoader().load(filename, (texture) => {

                const name = filename.replace("./emoji/", "").replace(".png", "");
                emotionsMaps[name] = texture;
                //console.log(name, texture)
            });
        }


        const material = new SpriteMaterial({ color: 0xffffff, depthTest: false, depthWrite: false });

        const sprite = new Sprite(material);
        sprite.name = "Emotion";
        sprite.position.y = 3;
        sprite.position.x = -1;
        scene.add(sprite);
        scene.getObjectByName("Emotion").visible = false;
        callback(filenames);
    };
    loadEmotions(emotions, (emotionsFilenames) => {

        var generatedImageOptions = [];
        for (let filename of emotionsFilenames) {
            const name = filename.replace("./emoji/", "").replace(".png", "");
            const option = [{
                "width": 64,
                "height": 64,
                "alt": name,
                "src": filename
            },
                name];
            generatedImageOptions.push(option)
        }


        for (let block of DIALOGS) {
            if (block.type === 'get_emotion') {

                block.args0[0].options = generatedImageOptions;
            }
        }

        loadStuff(stuff, (assets) => {
            onStuffLoaded(assets)
            for (let asset of assets) {
                characterAssets.push(asset)
                scene.add(asset);
                asset.visible = false;
            }
            loadCharacters(models, (assets) => {

                onCharactersLoaded(assets);
                for (let asset of assets) {
                    characterAssets.push(asset)
                    scene.add(asset);
                    asset.visible = false;
                }
                loadLocations(locations, (assets) => {
                    onLocationsLoaded(assets);
                    for (let asset of assets) {
                        loactionAssets.push(asset)
                        scene.add(asset);
                        asset.visible = false;
                    }
                    //console.log(loactionAssets)
                    initWorkspace();
                    session = new Session(playground);

                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);

                    if (urlParams.has('view')) {
                        storyID = urlParams.get('view');

                        session.getStory(storyID, (story) => {
                            if (story.length > 0) {
                                var usedToolboc = BASIC_TOOLBOX;
                                if (story[0].meta.mode == 'basic') {
                                    usedToolboc = TUTORIAL_TOOLBOX;
                                } else if (story[0].meta.mode == 'intermediate') {
                                    usedToolboc = BASIC_TOOLBOX;
                                } else if (story[0].meta.mode == 'advanced') {
                                    usedToolboc = ADVANCED_TOOLBOX;
                                }
                                if (story[0].meta.mode == 'javascript') {
                                    mode = 'hacker';
                                    document.querySelector('#editor').style.display = 'block';
                                    document.querySelector('#workspace').style.display = 'none';
                                    initEditor(story[0].meta.xml);
                                } else {
                                    initWorkspace(usedToolboc, story[0].slug, story[0].meta.xml);
                                }


                                //playground.setWorkspace();
                                if (urlParams.has('fullscreen')) {
                                    signal.emit('toggle-fullscreen');
                                    signal.emit('run');
                                } else {
                                    signal.emit("show-intro", story[0].title.rendered, story[0].excerpt.rendered)
                                }
                            }
                        })
                    } else if (urlParams.has('id')) {
                        const storyID = urlParams.get('id');
                        urlParams.delete('id');
                        var currURL = window.location.href; //get current address
                        var afterID = currURL.substring(currURL.lastIndexOf('?'));

                        window.history.replaceState({}, document.title, currURL.replace(afterID, ''));
                        session.getStory(storyID, (story) => {
                            if (story.length > 0)
                                playground.setWorkspace(story[0].meta.xml);
                        })
                    } else if (urlParams.has('wizard')) {
                        document.querySelector('#wizard-screen').style.display = 'flex';
                    }
                    const modes = document.querySelectorAll('div.wizard-choice');
                    for (let mode of modes) {
                        mode.addEventListener('click', (event) => {
                            signal.emit('change-mode', event.currentTarget.id.replace('wizard-', ''));

                        })
                    }
                    const sharingModes = document.querySelectorAll('div.sharing-choice');
                    for (let mode of sharingModes) {
                        mode.addEventListener('click', (event) => {
                            signal.emit('share', event.currentTarget.id.replace('share-', ''));

                        })
                    }

                    const linkGenerator = document.querySelector('#link-generator');
                    linkGenerator.addEventListener('click', () => {
                        signal.emit("get-link");
                    })
                })

            })
        })
    })

    signal.on('share', (sharingMode) => {
        var sharingModeHeaderText = "";
        if (sharingMode == 'remix') {
            sharingModeHeaderText = "Your story";
        } else if (sharingMode == 'activity') {
            sharingModeHeaderText = "Your training activity";
        }
        document.querySelector('#share-popup').className = sharingMode;
        document.querySelector('#share-mode-header').innerText = sharingModeHeaderText;
        document.querySelector('#step1').style.display = "block";
        document.querySelector('#step0').style.display = "none";

    })

    signal.on('get-link', () => {
        const title = document.querySelector('#story-title');
        const description = document.querySelector('#story-description');
        var mode = 'intermediate';
        for (let m of document.querySelectorAll('input[name="share-mode-coding-level"]')) {
            if (m.checked) {
                mode = m.value;
            }
        }
        document.querySelector('#step1').style.display = "none";
        document.querySelector('#step0').style.display = "none";
        document.querySelector('#step2').style.display = "block";
        session.share(title.value, description.value, mode, (story) => {
            console.log(story);
            document.querySelector('#step2').style.display = "none";
            document.querySelector('#step3').style.display = "block";
            var postUrl = ''
            if (document.querySelector('#share-popup').className == 'remix') {
                postUrl = '?fullscreen'
            }
            /*
            var currURL = location.href; //get current address
            var afterID = currURL.substring(currURL.lastIndexOf('?'));
            var baseUrl = currURL.indexOf('?') > 0 ? currURL.replace(afterID, '') : currURL;
            console.log(currURL, afterID, baseUrl)
            const url = `${baseUrl}?view=${story.post_name}${postUrl}`;
            const proxyUrl = url.replace("tool/?view=", "playground/");
            */
            const proxyUrl = location.origin + "/playground/" + story.post_name + postUrl;
            document.querySelector('#story-link').value = proxyUrl;
            document.querySelector('#story-a').href = proxyUrl;
            const sharingLinks = `Share on <a href="https://www.facebook.com/sharer/sharer.php?u=${proxyUrl}" target="_blank">Facebook</a> or 
            <a href="whatsapp://send?text=${proxyUrl}" target="_blank">WhatsApp</a>`;
            const sharingLinksDiv = document.querySelector("#share-on-social-links");
            sharingLinksDiv.innerHTML = sharingLinks;
        })
    })

    signal.on('open-share', () => {
        document.querySelector('#share-screen').style.display = 'flex';

        document.querySelector('#step0').style.display = "block";
        document.querySelector('#step1').style.display = "none";
        document.querySelector('#step2').style.display = "none";
        document.querySelector('#step3').style.display = "none";
    });

    signal.on('open-wizard', () => {
        document.querySelector('#wizard-screen').style.display = 'flex';
    });

    var fullscreen = false;
    signal.on('toggle-fullscreen', () => {
        if (!fullscreen) {
            document.querySelector('#editing-menu').style.display = 'none';
            document.querySelector('#workspace').style.display = 'none';
            document.querySelector('#stage').style.width = '100vw';
            document.querySelector('#my-playground').style.display = 'block';
        } else {
            document.querySelector('#editing-menu').style.display = 'flex';
            document.querySelector('#workspace').style.display = 'block';
            document.querySelector('#stage').style.width = '50vw';
            document.querySelector('#my-playground').style.display = 'grid'
        }
        fullscreen = !fullscreen;
        onWindowResize();
    });

    signal.on('close-popup', (selector) => {
        document.querySelector(selector).style.display = 'none';
    });

    signal.on('close-intro', (selector) => {
        document.querySelector(selector).style.display = 'none';
    });
    signal.on('show-intro', (title, description) => {
        console.log(title, description);
        document.querySelector('#intro-title').innerText = decodeHTMLEntities(title);
        document.querySelector('#intro-description').innerHTML = description;
        document.querySelector('#intro-screen').style.display = 'flex';
    });

    var editor;
    function initEditor(codeToShow) {
        if (!editor) {
            editor = CodeMirror.fromTextArea(document.getElementById("codeeditor"), {
                mode: 'javascript',
                theme: 'dracula',
                lineNumbers: true,
                styleActiveLine: true,
                matchBrackets: true,
                lineWrapping: true
            });
        }
        window.currentCodeEditor = editor;
        var localStorageJavascriptID = `fake-project-js${storyID ? '-' + storyID : ''}`;
        var lastCode = localStorage.getItem(localStorageJavascriptID);
        if (lastCode) {
            editor.setValue(lastCode)
        } else {
            editor.setValue(codeToShow);
        }

        editor.on("change", (event) => {
            localStorage.setItem(localStorageJavascriptID, event.getValue());
        })
    }
    var mode = 'beginner';

    signal.on('change-mode', (selectedMode) => {
        signal.emit('close-popup', '#wizard-screen');
        document.querySelector('#editor').style.display = 'none';
        //console.log(storyID)
        if (selectedMode == 'beginner') {
            mode = selectedMode;
            initWorkspace(TUTORIAL_TOOLBOX, storyID);
        } else if (selectedMode == 'intermediate') {
            mode = selectedMode;
            initWorkspace(BASIC_TOOLBOX, storyID);
        } else if (selectedMode == 'advanced') {
            mode = selectedMode;
            initWorkspace(ADVANCED_TOOLBOX, storyID);
        } else if (selectedMode == 'hacker') {
            mode = selectedMode;
            const codeToShow = playground.getCode();
            document.querySelector('#editor').style.display = 'block';
            document.querySelector('#workspace').style.display = 'none';
            initEditor(codeToShow);
        }
    })

    signal.on('run', (params) => {

        SimpleUI.disableAction('run');
        SimpleUI.enableAction('stop');
        lastAnswer = undefined;
        var code = "clear(); hide(); setLabel(); rotateCamera(0);";
        //console.log(document.querySelector("#workspace").style.display)
        if (mode != 'hacker') {
            code += playground.getCode();
            console.log(code)
        } else {
            code += editor.getValue();
        }
        //PATCH for String not existing in the interpreter
        code = code.replaceAll("String", "")
        //console.log("CODE",code)
        engine.run(code, () => {
            console.log("Completed")
            SimpleUI.disableAction('stop');
            SimpleUI.enableAction('run');
        });
    })

    signal.on('stop', () => {
        engine.stop();
        SimpleUI.disableAction('stop');
        SimpleUI.enableAction('run');
    })

    signal.on('change-language', () => {
        console.log("change")
        document.querySelector('#language-screen').style.display = 'flex';
    });

    signal.on('load-language', (lang) => {
        localStorage.setItem('fake-project-lang', lang);
        window.location.replace(window.location.pathname + window.location.search + window.location.hash);
    })
})